export default {
    popup: {
        maxWidth: "800px"
    },

    popupBody: {
        padding: "0px 60px 30px 40px",
    },

    consentRequestDetailsContaier: {
        display: "flex",
        flexDirection: "column",
        rowGap: "20px"
    },

    btnContainer: {
        display: "flex",
        alignItems: "center",
        columnGap: "20px"
    }
}